import { Injectable } from '@nestjs/common';
import { LotCodeOpsEntity } from '../entities/lot-code.entity';
import { LotCodeOpsDTO } from './lot-code.dto';
import { ProdInvDTO } from './prod-inv.dto';


@Injectable()
export class LotCodeOpsAdapter {
  

  public convertDtoToEntity(  lotCodeOpsDto: LotCodeOpsDTO,  isUpdate: boolean = false ): LotCodeOpsEntity {
    const lotCodeOps = new LotCodeOpsEntity();
    lotCodeOps.lotCodeOpsId=lotCodeOpsDto.lotCodeOpsId;
    lotCodeOps.grnDate=lotCodeOpsDto.grnDate;
    lotCodeOps.indentId = lotCodeOpsDto.indentId;
    lotCodeOps.grnNumber = lotCodeOpsDto.grnNumber;
    lotCodeOps.lotNumber = lotCodeOpsDto.lotNumber;
    lotCodeOps.saleOrderId = lotCodeOpsDto.saleOrderId;
    lotCodeOps.saleOrderItemId = lotCodeOpsDto.saleOrderItemId;
    lotCodeOps.supplierType = lotCodeOpsDto.supplierType;
    lotCodeOps.farmer = lotCodeOpsDto.farmer;
    lotCodeOps.farmerCode = lotCodeOpsDto.farmerCode;
    lotCodeOps.quantity = lotCodeOpsDto.quantity;
    lotCodeOps.count = lotCodeOpsDto.count;
    lotCodeOps.price = lotCodeOpsDto.price;
    lotCodeOps.boxes = lotCodeOpsDto.boxes;
    lotCodeOps.plantId = lotCodeOpsDto.plantId;
    lotCodeOps.subPlantId = lotCodeOpsDto.subPlantId;


   // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
    lotCodeOps.isActive=lotCodeOpsDto.isActive==undefined?true:lotCodeOpsDto.isActive;
    if (isUpdate) {
        lotCodeOps.updatedUser = lotCodeOpsDto.updatedUser;
    } else {
        lotCodeOps.isActive = true;
        lotCodeOps.createdUser = lotCodeOpsDto.createdUser;
        lotCodeOps.lotNumber=lotCodeOpsDto.lotNumber;
    }
   return lotCodeOps;
  }
  public convertEntityToDto(lotCodeOps: LotCodeOpsEntity): LotCodeOpsDTO {
    const lotCodeOpsDto= new LotCodeOpsDTO;
    lotCodeOpsDto.lotCodeOpsId=lotCodeOps.lotCodeOpsId;
    lotCodeOpsDto.grnDate=lotCodeOps.grnDate;
    lotCodeOpsDto.indentId=lotCodeOps.indentId;
    lotCodeOpsDto.grnNumber=lotCodeOps.grnNumber;
    lotCodeOpsDto.lotNumber=lotCodeOps.lotNumber;
    lotCodeOpsDto.saleOrderId=lotCodeOps.saleOrderId;
    lotCodeOpsDto.saleOrderItemId=lotCodeOps.saleOrderItemId;
    lotCodeOpsDto.supplierType=lotCodeOps.supplierType;
    lotCodeOpsDto.farmer=lotCodeOps.farmer;
    lotCodeOpsDto.farmerCode=lotCodeOps.farmerCode;
    lotCodeOpsDto.quantity=lotCodeOps.quantity;
    lotCodeOpsDto.count=lotCodeOps.count;
    lotCodeOpsDto.price=lotCodeOps.price;
    lotCodeOpsDto.boxes=lotCodeOps.boxes;
    lotCodeOpsDto.plantId=lotCodeOps.plantId;
    lotCodeOpsDto.subPlantId=lotCodeOps.subPlantId;
    lotCodeOpsDto.isActive = lotCodeOps.isActive;
    lotCodeOpsDto.createdAt = lotCodeOps.createdAt;
    lotCodeOpsDto.updatedAt = lotCodeOps.updatedAt;
    lotCodeOpsDto.createdUser = lotCodeOps.createdUser;
    lotCodeOpsDto.updatedUser = lotCodeOps.updatedUser;
    lotCodeOpsDto.versionFlag = lotCodeOps.versionFlag;
    return lotCodeOpsDto;
  }
}
